<template>
  <div>
    <components
      v-if="story.content"
      :key="story.id"
      :blok="story.content"
      :name="story.name"
      :is="story.content.component"
    />
  </div>
</template>
<script>
// Moved to helpers/editor.js
// const getParam = function(val) {
//   var result = "",
//     tmp = [];
//   location.search
//     .substr(1)
//     .split("&")
//     .forEach(function(item) {
//       tmp = item.split("=");
//       if (tmp[0] === val) result = decodeURIComponent(tmp[1]);
//     });
//   return result;
// };
// const loadStoryblokBridge = function(cb) {
//   let script = document.createElement("script");
//   script.type = "text/javascript";
//   script.src = `//app.storyblok.com/f/storyblok-latest.js?t=${getParam(
//     "token"
//   )}`;
//   script.onload = cb;
//   document.getElementsByTagName("head")[0].appendChild(script);
// };
import LayoutAstra from "../components/site/LayoutAstra.vue";

import LayoutDefault from "~/components/site/LayoutDefault.vue";
import LayoutShorthand from "~/components/site/LayoutShorthand.vue";
import LayoutSeal from "~/components/site/LayoutSeal.vue";

import LayoutProject from "~/components/site/LayoutProject.vue";
import LayoutInvestor from "@/components/site/LayoutInvestor.vue";
import LayoutInsurance from "~/components/site/LayoutInsurance.vue";
import LayoutNewsArticle from "@/components/site/LayoutNewsArticle.vue";
import LayoutNewsArchive from "@/components/site/LayoutNewsArchive.vue";
import LayoutTestimonials from "@/components/site/LayoutTestimonials.vue";

import LayoutSupporters from "@/components/site/LayoutSupporters.vue";
import LayoutGdpr from "@/components/site/LayoutGdpr.vue";
import LayoutNavigation from "@/components/site/LayoutNavigation.vue";
import LayoutFooter from "@/components/site/LayoutFooter.vue";
import LayoutTerraX from "@/components/site/LayoutTerraX.vue";
import LayoutTerraXFind from "~/components/site/LayoutTerraXFind.vue";

import server from "~/helpers/server.js";
import helper from "~/helpers/editor.js";

export default {
  name: "Editor",
  data() {
    return {
      story: { content: {} }
    };
  },
  metaInfo: {
    title: "Editor",
    meta: [
      {
        name: "robots",
        content: "noindex"
      }
    ]
  },
  components: {
    LayoutAstra,
    LayoutDefault,
    LayoutShorthand,
    LayoutSeal,
    LayoutTerraX,
    LayoutTerraXFind,
    LayoutProject,
    LayoutInvestor,
    LayoutInsurance,
    LayoutNewsArticle,
    LayoutNewsArchive,
    LayoutTestimonials,
    LayoutSupporters,
    LayoutNavigation,
    LayoutGdpr,
    LayoutFooter
  },
  watch: {
    $route(to, from) {
      if (to && from) {
        this.loadStory();
        this.initStoryblokEvents();
        this.$forceUpdate();
      }
    }
  },
  methods: {
    createBody: async (story, el) => {
      const news = await server.getAllNews(el, "draft");
      const supporters = await server.api(
        el,
        "draft",
        "global/list/supporters"
      );
      const testimonials = await server.getAllCeoTestimonials(el, "draft");
      const createBody = await server.buildData(
        story,
        news,
        supporters,
        testimonials
      );
      el.story = createBody;
    },
    loadStory() {
      window.storyblok.get(
        {
          slug: window.storyblok.getParam("path"),
          version: "draft",
          resolve_relations:
            "LayoutTestimonials.ceoTestimonials,CompSealTestimonials.ceoTestimonials"
        },
        data => {
          if (
            data.story.content.component === "LayoutDefault" ||
            data.story.content.component === "LayoutShorthand" ||
            data.story.content.component === "LayoutNewsArticle" ||
            data.story.content.component === "LayoutNewsArchive" ||
            data.story.content.component === "LayoutTestimonials"
          ) {
            this.createBody(data.story, this);
          } else {
            this.$store.commit("setLayout", data.story.content.component);
            this.story = data.story;
          }
        }
      );
    },
    // We dont need this
    // debounce(callback, delay) {
    //   let timeout;
    //   return function() {
    //     clearTimeout(timeout);
    //     timeout = setTimeout(callback, delay);
    //   };
    // },
    initStoryblokEvents() {
      let sb = window.storyblok;
      sb.on(["change", "published"], () => {
        this.loadStory();
      });
      sb.on("input", payload => {
        this.handleNewStoryData(payload.story);
      });
      sb.pingEditor(() => {
        if (sb.inEditor) {
          this.loadStory();
          sb.enterEditmode();
        }
      });
    },
    handleNewStoryData(newStory) {
      let sb = window.storyblok;
      if (this.story && newStory.id === this.story.id) {
        const hasCompSealTestimonials = Object.keys(newStory.content.body).some(
          k => newStory.content.body[k].component === "CompSealTestimonials"
        );
        if (
          newStory.content.component === "LayoutTestimonials" ||
          hasCompSealTestimonials
        ) {
          sb.addComments(newStory.content, newStory.id);
          sb.resolveRelations(
            newStory,
            [
              "LayoutTestimonials.ceoTestimonials",
              "CompSealTestimonials.ceoTestimonials"
            ],
            () => {
              this.createBody(newStory, this);
            }
          );
        } else {
          newStory.content = sb.addComments(newStory.content, newStory.id);

          this.story = newStory;
        }
      }
    }
  },
  mounted() {
    helper.loadStoryblokBridge(() => {
      this.$store.dispatch("editorData");
      this.loadStory();
      this.initStoryblokEvents();
    });
  }
};
</script>
